import { useEffect, useRef } from 'react'

import { DEFAULT_LOCALE_EN } from './locale'

/**
 * Creates an array of integers from start to end, inclusive
 */
export function range(start, end) {
  const array = []

  for (let i = start; i <= end; i++) {
    array.push(i)
  }

  return array
}

/**
 * Sorts an array of numbers
 */
export function sort(array) {
  array.sort(function (a, b) {
    return a - b
  })

  return array
}

/**
 * Removes duplicate entries from an array
 */
export function dedup(array) {
  const result = []

  array.forEach(function (i) {
    if (result.indexOf(i) < 0) {
      result.push(i)
    }
  })

  return result
}

/**
 * Simple classNames util function to prevent adding external library 'classnames'
 */
export function classNames(classes) {
  return Object.entries(classes)
    .filter(([key, value]) => key && value)
    .map(([key]) => key)
    .join(' ')
}

/**
 * Handle onError prop to set the error
 */
export function setError(onError, locale) {
  onError &&
    onError({
      type: 'invalid_cron',
      description:
        locale.errorInvalidCron || DEFAULT_LOCALE_EN.errorInvalidCron,
    })
}

/**
 * React useEffect hook to return the previous value
 */
export function usePrevious(value) {
  const ref = useRef(value)

  useEffect(() => {
    ref.current = value
  }, [value])

  return ref.current
}

/**
 * Convert a string to number but fail if not valid for cron
 */
export function convertStringToNumber(str) {
  const parseIntValue = parseInt(str, 10)
  const numberValue = Number(str)

  return parseIntValue === numberValue ? numberValue : NaN
}



export const SUPPORTED_SHORTCUTS = [
  {
    name: '@yearly',
    value: '0 0 1 1 *',
  },
  {
    name: '@annually',
    value: '0 0 1 1 *',
  },
  {
    name: '@monthly',
    value: '0 0 1 * *',
  },
  {
    name: '@weekly',
    value: '0 0 * * 0',
  },
  {
    name: '@daily',
    value: '0 0 * * *',
  },
  {
    name: '@midnight',
    value: '0 0 * * *',
  },
  {
    name: '@hourly',
    value: '0 * * * *',
  },
]
export const UNITS = [
  {
    type: 'minutes',
    min: 0,
    max: 59,
    total: 60,
  },
  {
    type: 'hours',
    min: 0,
    max: 23,
    total: 24,
  },
  {
    type: 'month-days',
    min: 1,
    max: 31,
    total: 31,
  },
  {
    type: 'months',
    min: 1,
    max: 12,
    total: 12,
    // DO NO EDIT
    // Only used internally for Cron syntax
    // alt values used for labels are in ./locale.ts file
    alt: [
      'JAN',
      'FEB',
      'MAR',
      'APR',
      'MAY',
      'JUN',
      'JUL',
      'AUG',
      'SEP',
      'OCT',
      'NOV',
      'DEC',
    ],
  },
  {
    type: 'week-days',
    min: 0,
    max: 6,
    total: 7,
    // DO NO EDIT
    // Only used internally for Cron syntax
    // alt values used for labels are in ./locale.ts file
    alt: ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'],
  },
]
